const HTTPS_PROTOCOL = 'https:';

function isHttpsUrl(url: string): boolean {
  try {
    return new URL(url).protocol === HTTPS_PROTOCOL;
  } catch {
    return false;
  }
}

/** Starts a download from a presigned URL with a same-tab transient anchor click. The URL is
 *  fetched asynchronously, so the user gesture is gone and a new tab could be popup-blocked; the
 *  storage host answers with Content-Disposition: attachment, so the SPA stays loaded. The app's
 *  Authorization header never reaches it. Returns false, opening nothing, unless the URL is https. */
export function openDownloadUrl(url: string): boolean {
  if (!isHttpsUrl(url)) return false;
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  return true;
}
